"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNewInactivityExpiration = void 0;
const util_1 = require("util");
const getNewInactivityExpiration = (idp) => {
    let maxInactivity;
    if (idp === null || idp === void 0 ? void 0 : idp.maxInactivity) {
        maxInactivity = idp.maxInactivity;
    }
    else {
        maxInactivity = (idp === null || idp === void 0 ? void 0 : idp.type) === 'admin' ? 120 : 30; // number of minutes of inactivity
    }
    if (!(0, util_1.isNumber)(maxInactivity)) {
        try {
            maxInactivity = parseInt(maxInactivity);
        }
        catch (e) {
            throw new Error(`Could not find a numeric value for maxInactivity: ${maxInactivity}`);
        }
    }
    return Date.now() + (maxInactivity * 60 * 1000); // number of milliseconds of inactivity, added to the current time
};
exports.getNewInactivityExpiration = getNewInactivityExpiration;
//# sourceMappingURL=getInactivityExpiration.js.map